export default {
  computed: {
    orderedPhotos() {
      return this.$store.getters.ORDERED_PHOTOS;
    },
  },
  methods: {
    getDownloadPhotos(favorite) {
      return favorite.items.filter((item) => +item.freeDownload);
    },
    deleteFromFavorites(data) {
      this.$store.dispatch('DELETE_FAVORITE', data);
      this.processedFavorites.forEach((favorite, index) => {
        if (this.$refs.isotope && this.$refs.isotope[index]) {
          this.$refs.isotope[index].layout('masonry')
        }
      });
    },
    getAlbumId(favorite) {
      if (favorite.albumStatus === '2') {
        return `${favorite.albumHash}-${favorite.albumHashPassword}`;
      }

      return favorite.albumId;
    },
    viewPhoto(albumId, photoId, favorite) {
      this.$store.dispatch('SET_SHOW_FAVORITE_PHOTO', true);
      this.$router.push(this.i18nLink(`album/gallery/${albumId}/order/${photoId}${favorite.tag ? `?tag=${favorite.tag}` : ''}`));
    },
    orderFavoritePhotos(favorite) {
      this.$store.dispatch('SET_ORDER_FAVORITE_PHOTOS', true);
      this.$router.push(this.i18nLink(`album/gallery/${this.getAlbumId(favorite)}${favorite.tag ? `?tag=${favorite.tag}` : ''}`));
    }
  },
};
